// Sent messages
export const NOTIFICATIONS_SETTING_CLICKED = 'NOTIFICATION_SETTING_CLICKED';

export const NEW_NOTIFICATION_SETTINGS = 'NEW_NOTIFICATION_SETTINGS';

export const REFERRAL_OPTION_CLICKED = 'REFERRAL_OPTION_CLICKED';

export const SET_SUPPORT_ZOOM = 'SET_SUPPORT_ZOOM';

export const SAVE_THEME_MODE = 'SAVE_THEME_MODE';

export const ACCOUNT_SELECTED = 'ACCOUNT_SELECTED';

export const SET_PRIMARY_ACCOUNT = 'SET_PRIMARY_ACCOUNT';

export const REMOVE_ACCOUNT = 'REMOVE_ACCOUNT';

export const RENDER_CAMPAIGN = 'RENDER_CAMPAIGN';

export const MODULE_CLICKED = 'MODULE_CLICKED';

export const MODULE_UPDATED = 'MODULE_UPDATED';
export const MODULE_SWITCHER_STATE = 'MODULE_SWITCHER_STATE';

// Signal yo check for microphone permission on native
export const GET_MICROPHONE_PERMISSION = 'GET_MICROPHONE_PERMISSION';

// Signal to add/remove a flag on native to keep screen on/off
export const KEEP_SCREEN_ON = 'KEEP_SCREEN_ON';

// Signal to track users interested in multi account support
export const ADD_ACCOUNT_BUTTON_CLICKED = 'ADD_ACCOUNT_BUTTON_CLICKED';

// Signal to open add account page
export const ADD_ACCOUNT_CLICKED = 'ADD_ACCOUNT_CLICKED';

export const ADD_GMAIL_ACCOUNT_CLICKED = 'ADD_GMAIL_ACCOUNT_CLICKED';

export const IN_APP_FEEDBACK_SUBMITTED = 'IN_APP_FEEDBACK_SUBMITTED';

// Update the native cache with the latest value
export const SYNC_OWA_USER_CONFIG = 'SYNC_OWA_USER_CONFIG';

export const SAVE_PARTIAL_SESSION_DATA = 'SAVE_SESSION_DATA';

export const SAVE_FOLDER_DATA = 'SAVE_FOLDER_DATA';

export const SAVE_CONVERSATION_ROWS_DATA = 'SAVE_CONVERSATION_ROWS_DATA';

export const SAVE_MESSAGES_ROWS_DATA = 'SAVE_MESSAGES_ROWS_DATA';

/** Received messages */
export const SOFTWARE_LICENSES_CLICKED = 'SOFTWARE_LICENSES_CLICKED';

export const NATIVE_NOTIFICATION_CLICKED = 'nativeNotificationClicked';

export const BOOT_FAILED = 'BOOT_FAILED';

export const END_CAMPAIGN = 'END_CAMPAIGN';

export const TELEMETRY_CONFIG_UPDATED = 'TELEMETRY_CONFIG_UPDATED';

// Signal received when microphone permission granted/denied from native side
export const MICROPHONE_PERMISSION_REQUEST_RESULT = 'MICROPHONE_PERMISSION_REQUEST_RESULT';

export const TRY_SMS_CLICKED_IN_CAMPAIGN = 'TRY_SMS_CLICKED_IN_CAMPAIGN';
